<template>
  <div class="title">{{$translation($websiteText().website_generals_new_password)}}</div>
  <div class="subtitle"></div>
  <div v-if="responseError.message" class="mt-3 error-message">
    <t-inline-message :message="responseError.message" severity="error" />
  </div>
  <div class="form">
    <t-form :onSubmit="changePassword" :schema="schema">
      <t-input-text
        type="password"
        v-model="state.password"
        name="password"
        :placeholder="$translation($websiteText().website_generals_password)"
        :onInputText="onInput"
      />
      <t-input-text
        type="password"
        name="confirmPassword"
        v-model="state.confirmPassword"
        :placeholder="$translation($websiteText().website_generals_confirm_password)"
        :onInputText="onInput"
      />

      <div class="submit-btn-container">
        <t-button type="submit" :label="$translation($websiteText().website_generals_change)" color="primary-color" />
      </div>
    </t-form>
  </div>
</template>
<script>
import { reactive } from "@vue/reactivity";
import TButton from "../../../common/components/buttons/TButton.vue";
import TInputText from "../../../common/components/input-text/TInputText.vue";
import TForm from "../../../common/components/TForm.vue";
import TInlineMessage from "../../../common/components/messages/TInlineMessage.vue";
import * as Yup from "yup";

import store from "../../../store";
import {
  CHANGE_PASSWORD_REQUEST,
  REPLACE_AUTH_ACTIVE_COMPONENT,
} from "../store/actions";
import { useRoute, useRouter } from "vue-router";
import Signin from "./Signin.vue";
import { onMounted } from "@vue/runtime-core";
export default {
  name:"ChangePassword",
  components: {
    TButton,
    TInputText,
    TForm,
    TInlineMessage,
  },

  setup() {
    const router = useRouter();
    const route = useRoute();

    let responseError = reactive({
      message: "",
    });

    const state = reactive({
      password: "",
      confirmPassword: "",
    });

    const onInput = () => {
      responseError.message = "";
    };

    const schema = Yup.object().shape({
      password: Yup.string().required().min(6).label("Password"),
      confirmPassword: Yup.string().oneOf(
        [Yup.ref("password"), null],
        "Passwords must match"
      ),
    });

    const changePassword = () => {
      store
        .dispatch(CHANGE_PASSWORD_REQUEST, {
          password: state.password,
          email: route.params.email,
        })
        .then(() => {
          localStorage.setItem("email", route.params.email);
          localStorage.setItem("password", "");
          store.dispatch(REPLACE_AUTH_ACTIVE_COMPONENT, Signin);
          router.push({ name: "Home" });
        })
        .catch((e) => {
          responseError.message = e.response.data.message;
        });
    };

    return {
      schema,
      changePassword,
      state,
      responseError,
      onInput,
      store,
    };
  },
};
</script>
<style lang="scss" scoped >
.title {
  margin-top: 2.1%;
  @include f-h3;
}
.subtitle {
  margin-top: 1.9%;
  @include f-body1;
  color: $dark-grey2;
}

.error-message {
  margin-bottom: -2%;
}

.form {
  margin-top: 1.7%;

  input:first-of-type {
    margin-bottom: 1.2%;
  }

  .submit-btn-container {
    width: 100%;
    text-align: center;
  }
}
</style>

